import { setOrganizationFullAddress } from 'src/utils/escrow';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Card, CardHeader, CardContent, CardDescription, CardTitle, CardFooter } from '@/components/ui/card';

import { useDepositorContext } from '../model';

import EditDepositorDialog from './EditDepositorDialog';

const DepositorOrganization = () => {
  const { depositor } = useDepositorContext();

  const address = {
    street: depositor?.street || '',
    streetNumber: depositor?.streetNumber || '',
    city: depositor?.city || '',
    postalCode: depositor?.postalCode || '',
    region: depositor?.region || '',
    country: depositor?.country || '',
  };

  const rows = [
    {
      id: 'organization-name',
      label: 'Organization Name',
      value: depositor?.companyName,
    },
    {
      id: 'website',
      label: 'Website',
      value: depositor?.companyWebsite || '-',
    },
    {
      id: 'registration-number',
      label: 'Registration Number',
      value: depositor?.companyRegistrationNumber || '-',
    },
    {
      id: 'address',
      label: 'Address',
      value: setOrganizationFullAddress(address),
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Depositor organization details</CardTitle>
        <CardDescription>
          What are your company&apos;s details? This includes the registered name and address of the entity, which will
          be listed in the escrow agreement.
        </CardDescription>
      </CardHeader>
      <CardContent className="pb-0">
        <Table className="border-y border-border">
          <TableBody>
            {rows.map(({ id, label, value }) => (
              <TableRow key={id} className="hover:bg-white">
                <TableCell className="pl-0 py-3 w-50 font-semibold text-slate-700">{label}</TableCell>
                <TableCell className="py-3 px-0 w-4">:</TableCell>
                <TableCell className="py-3 text-foreground">
                  <div className="min-w-47.5">{value}</div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      {depositor?.policy.update && (
        <CardFooter className="pt-3 justify-end">
          <EditDepositorDialog />
        </CardFooter>
      )}
    </Card>
  );
};

export default DepositorOrganization;
